<script setup lang="ts">

import FeaturePanel from "./FeaturePanel.vue";

let featureCounter = 0;

</script>

<template>

    <div class="max-w-5xl mx-auto md:px-12 px-4">
    
        <div class="text-center tracking-wider py-16 px-4 bg-gray-50 rounded-3xl">
            <h1 class="text-5xl font-semibold">
                What you get
            </h1>

            <!-- CARBUCKS APP-->
            <FeaturePanel>
                <template #image>
                    <img src="@/assets/images/Screenshots/my-garage.png" class="w-4/5 md:w-full"/>
                </template>
                <template #icon>
                    <img src="@/assets/images/Home/icon-app.png" class="w-16 mx-auto md:mx-0"/>
                </template>                
                <template #headline>
                    The Carbucks <span class="text-primary-600 font-bold uppercase">App</span>
                </template>                
                Get a better automotive experience with exclusive deals,
                personalised recommendations, and effortless scheduling - making your
                journey easier and more rewarding.
            </FeaturePanel>

            <!-- CARBUCKS REWARDS -->
            <FeaturePanel :is-reversed="featureCounter++ % 2 == 0">
                <template #image>
                    <img src="@/assets/images/Screenshots/rewards.png" class="w-4/5 md:w-full md:-mx-16 my-16"/>
                </template>
                <template #icon>
                    <img src="@/assets/images/Home/icon-health-monitor.png" class="w-16 mx-auto md:mx-0"/>
                </template>                
                <template #headline>
                    Carbucks <span class="text-primary-600 font-bold uppercase">REWARDS</span>
                </template>   
                <p class="mb-2">
                    A free loyalty service from your dealership, to keep you on the road when the unexpected happens.
                </p>   
                <ul class="list-disc list-outside ml-4">
                    <li>
                        <strong class="text-emerald-500">FREE</strong> vehicle health checks ahead of those long trips
                    </li>
                </ul>          
            </FeaturePanel>

            <!-- CARBUCKS PROTECT-->
            <FeaturePanel :is-reversed="featureCounter++ % 2 == 0">
                <template #image>
                    <img src="@/assets/images/Screenshots/protect.png" class="w-4/5 md:w-full"/>
                </template>
                <template #icon>
                    <img src="@/assets/images/Home/icon-protect.png" class="w-20 mx-auto md:mx-0"/>
                </template>                
                <template #headline>
                    Carbucks <span class="text-primary-600 font-bold uppercase">Protect</span>
                </template>                
                <p class="mb-2">
                    Protects the parts of your car that you can't get covered by a warranty, 
                    eliminating bill-shock and keeping your running costs as low as possible.
                </p>   
                <ul class="list-disc list-outside ml-4">
                    <li>
                        12v Battery replacement <strong class="text-emerald-500">COVERED</strong>
                    </li>
                    <li>
                        Brake pads, drums and rotors <strong class="text-emerald-500">COVERED</strong>
                    </li>
                    <li>
                        Tyres replacement <strong class="text-emerald-500">COVERED</strong>
                    </li>
                    <li>
                        Wiper blade replacement <strong class="text-emerald-500">COVERED</strong>
                    </li>
                    <li>
                        Key fob repairs <strong class="text-emerald-500">COVERED</strong>
                    </li>
                </ul>          
                <p class="mt-2 text-base">
                    All replacements with manufacturer approved parts where possible
                </p>   
            </FeaturePanel>

            <!-- HEALTH MONITOR -->
            <!-- <FeaturePanel :is-reversed="featureCounter++ % 2 == 0">
                <template #image>
                    <img src="@/assets/images/Screenshots/screenshot-with-health-monitor.png" class="w-4/5 md:w-full md:-mx-16 scale-[120%] my-16"/>
                </template>
                <template #icon>
                    <img src="@/assets/images/Home/icon-health-monitor.png" class="w-16 mx-auto md:mx-0"/>
                </template>                
                <template #headline>
                    The Carbucks <span class="text-primary-600 font-bold uppercase">Health Monitor</span>
                </template>                
                Seamlessly integrates innovative wellness insights into your cars'
                health and performance.  Get real-time diagnostics, maintenance reminders
                and safety warnings, and redefine how you drive.
            </FeaturePanel> -->

            <!-- MARKETPLACE-->
            <FeaturePanel :is-reversed="featureCounter++ % 2 == 0">
                <template #image>
                    <img src="@/assets/images/Screenshots/marketplace.png" class="w-4/5 md:w-full"/>
                </template>
                <template #icon>
                    <img src="@/assets/images/Home/icon-marketplace.png" class="w-16 mx-auto md:mx-0"/>
                </template>                
                <template #headline>
                    Marketplace <span class="text-primary-600 font-bold uppercase">Rewards</span>
                </template>                
                Rewarding you for driving with curated offerings, exclusive deals, big automotive discounts
                and seamless transactions.
            </FeaturePanel>

            <!-- CONCIERGE-->
            <FeaturePanel :is-reversed="featureCounter++ % 2 == 0">
                <template #image>
                    <img src="@/assets/images/Screenshots/screenshot-concierge.png" class="w-4/5 md:w-full"/>
                </template>
                <template #icon>
                    <img src="@/assets/images/Home/icon-concierge.png" class="w-16 mx-auto md:mx-0"/>
                </template>                
                <template #headline>
                    <span class="text-primary-600 font-bold uppercase">VIP</span> Concierge
                </template>                
                <p>
                    Meet our friendly concierge, always at your service, ready to help you
                    in an emergency, or just to help you book your car in for maintenance and servicing.
                    We've got you covered 24/7.  
                </p>
                <p class="pt-2">
                    And unlike those pesky 'A.I.' and chatbot solutions, we hire people, so you're guaranteed
                    a warm and friendly, human experience and a genuine solution to your needs.
                </p>

            </FeaturePanel>

        </div>
    
    </div>


    
</template>